import {connect} from 'react-redux'
import * as ordersActions from "../actions/ordersActions";
import * as userActions from "../actions/usersActions";
import * as businessActions from "../actions/businessActions";
import * as profilesActions from "../actions/profilesActions";
import * as distributionAreasActions from "../actions/distributionAreasActions";
import DeliveriesDashboard from "../../Views/DeliveriesDashboard/DeliveriesDashboard";

const mapStateToProps = (store) => {
    return {
        ordersFetched: store.ordersReducer.fetched,
        businessFetched: store.businessReducer.fetched,
        usersFetched: store.usersReducer.fetched,
        profilesFetched: store.profilesReducer.fetched
    };
};

const mapDispatchToProps = {
    fetchOrders: ordersActions.fetchOrdersAction,
    fetchUsers: userActions.fetchUsersAction,
    fetchBusiness: businessActions.fetchBusinessAction,
    fetchProfiles: profilesActions.fetchProfilesAction,
    fetchDistributionAreas: distributionAreasActions.fetchDistributionAreasAction
};

const DeliveriesDashboardContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveriesDashboard);

export default DeliveriesDashboardContainer;